import { useState } from 'react'
import {
  Button,
  Modal, Dialog
} from 'react-aria-components'
import Message from './Message.js'

export default function Conversation ({ isOpen, onClose, messages, from }) {
  const [msgIndex, setMsgIndex] = useState(1)

  const incrementMsgNum = () => {
    setMsgIndex(msgIndex + 1)
  }
  const showCloseButton = msgIndex >= messages.length
  const initial = from ? from.charAt(0).toUpperCase() : '?'

  return (
    <div onClick={incrementMsgNum}>
      <Modal isOpen={isOpen} className='flex z-1000 fixed top-0 h-dvh w-screen'>
        <div className='flex-1 backdrop-blur-xs' />
        <Dialog className='drop-yellow flex-11 md:flex-5 flex flex-col min-h-0 mb-16 bg-[#efeff4] overflow-hidden rounded-3xl border-4 border-black outline-none'>
          <div className='shrink-0 flex flex-col items-center bg-white/90 backdrop-blur-sm border-b-2 border-black pt-4 pb-3'>
            <div className='w-12 h-12 flex items-center justify-center rounded-full border-2 border-black bg-gradient-to-br from-gray-400 to-gray-600 text-white text-lg font-semibold font-sans'>
              {initial}
            </div>
            <div className='mt-1 font-sans font-semibold text-gray-900'>{from}</div>
            <div className='font-sans text-xs text-gray-400'>Text Message</div>
          </div>
          <div className='flex-1 overflow-y-auto min-h-0 px-2 py-3'>
            {messages && messages.slice(0, msgIndex).map((message, i) => (
              <Message key={i} isFromMe={message.isFromMe}>{message.text}</Message>
            ))}
            {!showCloseButton && (
              <div className='font-sans text-center text-gray-400 italic text-sm mt-2 animate-pulse'>Tap to continue...</div>
            )}
          </div>
          {showCloseButton && (
            <div className='shrink-0 bg-white/90 backdrop-blur-sm border-t-2 border-black p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]'>
              <Button onPress={onClose} className='mx-auto block w-2/3 md:w-1/2 py-2.5 text-center font-sans font-medium text-white bg-[#0B93F6] border-2 border-black rounded-full'>
                Close
              </Button>
            </div>
          )}
        </Dialog>
        <div className='flex-1 backdrop-blur-xs' />
      </Modal>
    </div>
  )
}
